export const getQuestionsSuccess = (payload) => {
  return {
    type: "GET_QUESTIONS_SUCCESS",
    payload
  };
}

export const getQuestionsFail = (payload) => {
  return {
    type: "GET_QUESTIONS_FAIL",
  };
}

export const submitFormSuccess = (payload) => {
  return {
    type: "SUBMIT_FORM_SUCCESS",
    payload
  };
}

export const submitFormFail = (payload) => {
  return {
    type: "SUBMIT_FORM_FAIL",
  };
}
